import { createSelector } from 'reselect';

import { RootState } from '@ezugi/bootstrap';

import * as BET_TYPES from '../../constants/betTypes';
import { WINNING_HANDS } from '../../constants/winningHands';
import { StatisticState } from '../reducers/statistics';

const {
  MAIN_BETS: { PLAYER_A, PLAYER_B },
} = BET_TYPES;

type GameResults = {
  // NOT COMPLETE TYPE
  WinningHand: typeof WINNING_HANDS.WinPlayerA | typeof WINNING_HANDS.WinPlayerB | typeof WINNING_HANDS.Push;
};
type RootStateWithGamesResults = Omit<RootState, 'game'> & {
  game: RootState['game'] & { gameResults: GameResults };
};
type RootStateWithRound = Omit<RootState, 'round'> & {
  round: RootState['round'] & { roundSkippedPYB?: boolean };
};
type RootStateWithStatistics = RootState & { statistics: StatisticState };
type RootStateWithConfig = Omit<RootState, 'config'> & {
  config: RootState['config'] & { isBackAndLayTable?: boolean };
};

export const gameResultsSelector = (state: RootStateWithGamesResults) => state.game.gameResults || {};
export const statisticsSelector = (state: RootStateWithStatistics) => state.statistics || {};

export const lastWinnersSelector = createSelector(
  statisticsSelector,
  (statistics) => statistics.lastWinners || [],
);

export const winningMainBetsSelector = createSelector(
  gameResultsSelector,
  (gameResults) => {
    const { WinningHand } = gameResults;

    return WinningHand !== WINNING_HANDS.Push
      ? [ WinningHand === WINNING_HANDS.WinPlayerA ? PLAYER_A : PLAYER_B ]
      : [];
  },
);

export const winningSideBetsSelector = createSelector(
  gameResultsSelector,
  (gameResults) => {
    // TODO: revisit if non back and lay flavour will be picked up again
    // @ts-ignore
    const { SideBetsResult = [] } = gameResults;

    // TODO: revisit if non back and lay flavour will be picked up again
    // @ts-ignore
    const bets = SideBetsResult.reduce((acc, curr) => {
      if (curr.HasSideBetWon) {
        return [ ...acc, curr.betType ];
      }

      return acc;
    }, []);

    return bets;
  },
);

export const winningBetsSelector = createSelector(
  winningMainBetsSelector,
  winningSideBetsSelector,
  (winningMainBets, winningSideBets) => winningMainBets.concat(winningSideBets),
);

export const isBackAndLaySelector = (state: RootStateWithConfig) => state.game.gameId === '50'
|| (state.config.isBackAndLayTable || false);

export const roundSkippedPYBSelector = (state: RootStateWithRound) => state.round?.roundSkippedPYB || false;
